import { CITY_LANDING_PAGE_IDS } from '@/pages/city_landing/page_ids';

pageLoad(...CITY_LANDING_PAGE_IDS, () => {
  const $article = $('article.v4.prices');

  $article.find('.period').on('click', ({ currentTarget }) => {
    const band = currentTarget.getAttribute('data-band');

    $article.find('.period').removeClass('is-active');
    currentTarget.classList.add('is-active');

    $article.find('.amounts .current').removeClass('is-active');
    $article.find(`.amounts .current[data-band="${band}"]`).addClass('is-active');
  });
});
